import React from 'react';

/**
 * props:
 * - id
 * - label
 * - placeholder
 * - rows
 * - required
 * - value
 * - onChange
 */
function AuthTextarea(props) {
  return (
    <div className="auth-field">
      <label htmlFor={props.id}>{props.label}</label>
      <div className="auth-input-wrap auth-input-wrap--textarea">
        <textarea
          id={props.id}
          rows={props.rows || 5}
          placeholder={props.placeholder}
          required={props.required !== false}
          value={props.value}
          onChange={props.onChange}
        />
      </div>
    </div>
  );
}

export default AuthTextarea;